import { render } from "./QuickSearchContactCardElement.vue?vue&type=template&id=02771e76&scoped=true"
import script from "./QuickSearchContactCardElement.vue?vue&type=script&lang=js"
export * from "./QuickSearchContactCardElement.vue?vue&type=script&lang=js"

import "./QuickSearchContactCardElement.vue?vue&type=style&index=0&id=02771e76&lang=scss&scoped=true"
/* custom blocks */
import block0 from "@/locales/common.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Fapp%2Fsrc%2Fcomponents%2Felements%2Fquick_search%2Fcards%2FQuickSearchContactCardElement.vue&external"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/components/elements/quick_search/quick-search-contact-card-element.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fusr%2Fapp%2Fsrc%2Fcomponents%2Felements%2Fquick_search%2Fcards%2FQuickSearchContactCardElement.vue&external"
if (typeof block1 === 'function') block1(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02771e76"]])

export default __exports__